import { AxiosInstance } from "axios";
import { HubUserActivityApiFactory } from "../common/data/service-proxies";

export const activityService = {
  /**
   * Ping the backend to indicate user activity
   */
  pingActivity: async (axiosInstance: AxiosInstance): Promise<void> => {
    try {
      const apiFactory = HubUserActivityApiFactory(
        undefined,
        axiosInstance.defaults.baseURL,
        axiosInstance
      );
      await apiFactory.apiAppHubuseractivitySendpulsePost();
    } catch (error) {
      console.error("Failed to ping activity:", error);
      throw error;
    }
  },
};
